export const rows = [
  {
    id: 1,
    acc_description_edit: 'Labor, Personnel Costs',
    jan: ' 1.213.600',
    feb: ' 1.592.850',
    mar: ' 1.517.000',
    apr: ' 1.638.360',
    may: ' 1.638.360',
    jun: ' 1.638.360',
    jul: ' 1.638.360',
    aug: ' 1.638.360',
    sep: ' ',
    oct: ' ',
    nov: ' ',
    dec: ' ',
    parentId: null,
    type: 'step',

  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '01 Salaries and wages',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '02 Reversal of vacations provisions',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 1,
      },
      {
        id: "1.1",
        acc_description_edit: '05 Others Personnel Costs',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 1,
      },
          {
            id:  Math.random().toString(36).substr(2, 9),
            acc_description_edit: '        Bonus and profit sharing',
            jan: ' 1.213.600',
            feb: ' 1.592.850',
            mar: ' 1.517.000',
            apr: ' 1.638.360',
            may: ' 1.638.360',
            jun: ' 1.638.360',
            jul: ' 1.638.360',
            aug: ' 1.638.360',
            sep: ' ',
            oct: ' ',
            nov: ' ',
            dec: ' ',
            type: 'row',
            parentId: "1.1",
          },
          {
            id:  Math.random().toString(36).substr(2, 9),
            acc_description_edit: '        Holiday/vacation',
            jan: ' 1.213.600',
            feb: ' 1.592.850',
            mar: ' 1.517.000',
            apr: ' 1.638.360',
            may: ' 1.638.360',
            jun: ' 1.638.360',
            jul: ' 1.638.360',
            aug: ' 1.638.360',
            sep: ' ',
            oct: ' ',
            nov: ' ',
            dec: ' ',
            type: 'row',
            parentId: "1.1",
          },
          {
            id:  Math.random().toString(36).substr(2, 9),
            acc_description_edit: '        Other personnel',
            jan: ' 1.213.600',
            feb: ' 1.592.850',
            mar: ' 1.517.000',
            apr: ' 1.638.360',
            may: ' 1.638.360',
            jun: ' 1.638.360',
            jul: ' 1.638.360',
            aug: ' 1.638.360',
            sep: ' ',
            oct: ' ',
            nov: ' ',
            dec: ' ',
            type: 'row',
            parentId: "1.1",
          },
          {
            id:  Math.random().toString(36).substr(2, 9),
            acc_description_edit: '        Overtime',
            jan: ' 1.213.600',
            feb: ' 1.592.850',
            mar: ' 1.517.000',
            apr: ' 1.638.360',
            may: ' 1.638.360',
            jun: ' 1.638.360',
            jul: ' 1.638.360',
            aug: ' 1.638.360',
            sep: ' ',
            oct: ' ',
            nov: ' ',
            dec: ' ',
            type: 'row',
            parentId: "1.1",
          },
          {
            id:  Math.random().toString(36).substr(2, 9),
            acc_description_edit: '        Pension/preretirement',
            jan: ' 1.213.600',
            feb: ' 1.592.850',
            mar: ' 1.517.000',
            apr: ' 1.638.360',
            may: ' 1.638.360',
            jun: ' 1.638.360',
            jul: ' 1.638.360',
            aug: ' 1.638.360',
            sep: ' ',
            oct: ' ',
            nov: ' ',
            dec: ' ',
            type: 'row',
            parentId: "1.1",
          },
          {
            id:  Math.random().toString(36).substr(2, 9),
            acc_description_edit: '        Social charges',
            jan: ' 1.213.600',
            feb: ' 1.592.850',
            mar: ' 1.517.000',
            apr: ' 1.638.360',
            may: ' 1.638.360',
            jun: ' 1.638.360',
            jul: ' 1.638.360',
            aug: ' 1.638.360',
            sep: ' ',
            oct: ' ',
            nov: ' ',
            dec: ' ',
            type: 'row',
            parentId: "1.1",
          },
          {
            id:  Math.random().toString(36).substr(2, 9),
            acc_description_edit: '        Wages & salaries',
            jan: ' 1.213.600',
            feb: ' 1.592.850',
            mar: ' 1.517.000',
            apr: ' 1.638.360',
            may: ' 1.638.360',
            jun: ' 1.638.360',
            jul: ' 1.638.360',
            aug: ' 1.638.360',
            sep: ' ',
            oct: ' ',
            nov: ' ',
            dec: ' ',
            type: 'row',
            parentId: "1.1",
          },

      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '08 Sales Comissions',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '09 Travel, entertain, and missions represantations',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '12 Insurance',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '17 Office costs and consumptions',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '20 Personnel Training and Seminars',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '21 Temporary, Trainees and Subcontracting',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '24 Other expenses',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '34 Cost Allocation',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '46 Others Provisions',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 1,
      },

      {
        id:  "1.2",
        acc_description_edit: 'Without Classification',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 1,
      },
          {
            id:  Math.random().toString(36).substr(2, 9),
            acc_description_edit: '        Information Technology',
            jan: ' 1.213.600',
            feb: ' 1.592.850',
            mar: ' 1.517.000',
            apr: ' 1.638.360',
            may: ' 1.638.360',
            jun: ' 1.638.360',
            jul: ' 1.638.360',
            aug: ' 1.638.360',
            sep: ' ',
            oct: ' ',
            nov: ' ',
            dec: ' ',
            type: 'row',
            parentId: "1.2",
          },
          {
            id:  Math.random().toString(36).substr(2, 9),
            acc_description_edit: '        not assigned',
            jan: ' 1.213.600',
            feb: ' 1.592.850',
            mar: ' 1.517.000',
            apr: ' 1.638.360',
            may: ' 1.638.360',
            jun: ' 1.638.360',
            jul: ' 1.638.360',
            aug: ' 1.638.360',
            sep: ' ',
            oct: ' ',
            nov: ' ',
            dec: ' ',
            type: 'row',
            parentId: "1.2",
          },
          {
            id:  Math.random().toString(36).substr(2, 9),
            acc_description_edit: '        Other personnel',
            jan: ' 1.213.600',
            feb: ' 1.592.850',
            mar: ' 1.517.000',
            apr: ' 1.638.360',
            may: ' 1.638.360',
            jun: ' 1.638.360',
            jul: ' 1.638.360',
            aug: ' 1.638.360',
            sep: ' ',
            oct: ' ',
            nov: ' ',
            dec: ' ',
            type: 'row',
            parentId: "1.2",
          },
          {
            id:  Math.random().toString(36).substr(2, 9),
            acc_description_edit: '        Overtime',
            jan: ' 1.213.600',
            feb: ' 1.592.850',
            mar: ' 1.517.000',
            apr: ' 1.638.360',
            may: ' 1.638.360',
            jun: ' 1.638.360',
            jul: ' 1.638.360',
            aug: ' 1.638.360',
            sep: ' ',
            oct: ' ',
            nov: ' ',
            dec: ' ',
            type: 'row',
            parentId: "1.2",
          },
          {
            id:  Math.random().toString(36).substr(2, 9),
            acc_description_edit: '        Payroll tax',
            jan: ' 1.213.600',
            feb: ' 1.592.850',
            mar: ' 1.517.000',
            apr: ' 1.638.360',
            may: ' 1.638.360',
            jun: ' 1.638.360',
            jul: ' 1.638.360',
            aug: ' 1.638.360',
            sep: ' ',
            oct: ' ',
            nov: ' ',
            dec: ' ',
            type: 'row',
            parentId: "1.2",
          },
          {
            id:  Math.random().toString(36).substr(2, 9),
            acc_description_edit: '        Personnel cost',
            jan: ' 1.213.600',
            feb: ' 1.592.850',
            mar: ' 1.517.000',
            apr: ' 1.638.360',
            may: ' 1.638.360',
            jun: ' 1.638.360',
            jul: ' 1.638.360',
            aug: ' 1.638.360',
            sep: ' ',
            oct: ' ',
            nov: ' ',
            dec: ' ',
            type: 'row',
            parentId: "1.2",
          },
          {
            id:  Math.random().toString(36).substr(2, 9),
            acc_description_edit: '        Wages & salaries',
            jan: ' 1.213.600',
            feb: ' 1.592.850',
            mar: ' 1.517.000',
            apr: ' 1.638.360',
            may: ' 1.638.360',
            jun: ' 1.638.360',
            jul: ' 1.638.360',
            aug: ' 1.638.360',
            sep: ' ',
            oct: ' ',
            nov: ' ',
            dec: ' ',
            type: 'row',
            parentId: "1.2",
          },

  {
    id: 2,
    acc_description_edit: 'Travel & Entertainment',
    jan: ' 1.213.600',
    feb: ' 1.592.850',
    mar: ' 1.517.000',
    apr: ' 1.638.360',
    may: ' 1.638.360',
    jun: ' 1.638.360',
    jul: ' 1.638.360',
    aug: ' 1.638.360',
    sep: ' ',
    oct: ' ',
    nov: ' ',
    dec: ' ',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '09 Travel, entertain, and missions represantations',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 2,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: 'Without Classification',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 2,
      },

  {
    id: 3,
    acc_description_edit: 'Rental & lease',
    jan: ' 1.213.600',
    feb: ' 1.592.850',
    mar: ' 1.517.000',
    apr: ' 1.638.360',
    may: ' 1.638.360',
    jun: ' 1.638.360',
    jul: ' 1.638.360',
    aug: ' 1.638.360',
    sep: ' ',
    oct: ' ',
    nov: ' ',
    dec: ' ',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '14 Lodging',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 3,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '15 Buildings, equipments and tools',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 3,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: 'Without Classification',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 3,
      },

  {
    id: 4,
    acc_description_edit: 'Repair ¨& Maintenance, utilities',
    jan: ' 1.213.600',
    feb: ' 1.592.850',
    mar: ' 1.517.000',
    apr: ' 1.638.360',
    may: ' 1.638.360',
    jun: ' 1.638.360',
    jul: ' 1.638.360',
    aug: ' 1.638.360',
    sep: ' ',
    oct: ' ',
    nov: ' ',
    dec: ' ',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '15 Buildings, equipments and tools',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 4,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '17 Office costs and consumptions',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 4,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '24 Other expenses',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 4,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: 'Without Classification',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 4,
      },

  {
    id: 5,
    acc_description_edit: 'Promotion & Advertising',
    jan: ' 1.213.600',
    feb: ' 1.592.850',
    mar: ' 1.517.000',
    apr: ' 1.638.360',
    may: ' 1.638.360',
    jun: ' 1.638.360',
    jul: ' 1.638.360',
    aug: ' 1.638.360',
    sep: ' ',
    oct: ' ',
    nov: ' ',
    dec: ' ',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '06 Promotion and advertising',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 5,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '08 Sales Comissions',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 5,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '21 Temporary, Trainees and Subcontractings',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 5,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '23 Warranty Costs',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 5,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: 'Without Classification',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 5,
      },

  {
    id: 6,
    acc_description_edit: 'Depreciation & Amortization',
    jan: ' 1.213.600',
    feb: ' 1.592.850',
    mar: ' 1.517.000',
    apr: ' 1.638.360',
    may: ' 1.638.360',
    jun: ' 1.638.360',
    jul: ' 1.638.360',
    aug: ' 1.638.360',
    sep: ' ',
    oct: ' ',
    nov: ' ',
    dec: ' ',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '25 Depreciation and amortization',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 6,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: 'Without Classification',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 6,
      },

  {
    id: 7,
    acc_description_edit: 'IFRS 9 provision',
    jan: ' 1.213.600',
    feb: ' 1.592.850',
    mar: ' 1.517.000',
    apr: ' 1.638.360',
    may: ' 1.638.360',
    jun: ' 1.638.360',
    jul: ' 1.638.360',
    aug: ' 1.638.360',
    sep: ' ',
    oct: ' ',
    nov: ' ',
    dec: ' ',
    parentId: null,
    type: 'step',
  },
      {
    id:  Math.random().toString(36).substr(2, 9),
    acc_description_edit: 'Without Classification',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
    type: 'row',
    parentId: 7,
  },

  {
    id: 8,
    acc_description_edit: 'Other provisions',
    jan: ' 1.213.600',
    feb: ' 1.592.850',
    mar: ' 1.517.000',
    apr: ' 1.638.360',
    may: ' 1.638.360',
    jun: ' 1.638.360',
    jul: ' 1.638.360',
    aug: ' 1.638.360',
    sep: ' ',
    oct: ' ',
    nov: ' ',
    dec: ' ',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '18 Services Contracts (Security, Other 3rd Serv)',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '19 Taxes & related costs',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '23 Warranty Costs',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '24 Other expenses',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '25 Depreciation and amortization',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '44 Provisions for doubtful accounts',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '46 Others Provisions',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: 'Without Classification',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 8,
      },

  {
    id: 9,
    acc_description_edit: 'External fees & related costs',
    jan: ' 1.213.600',
    feb: ' 1.592.850',
    mar: ' 1.517.000',
    apr: ' 1.638.360',
    may: ' 1.638.360',
    jun: ' 1.638.360',
    jul: ' 1.638.360',
    aug: ' 1.638.360',
    sep: ' ',
    oct: ' ',
    nov: ' ',
    dec: ' ',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '11 External fees and related costs',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 9,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '19 Taxes & related costs',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 9,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '21 Temporary, Trainees and Subcontracting',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 9,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '24 Other expenses',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 9,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: 'Without Classification',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 9,
      },

  {
    id: 10,
    acc_description_edit: 'Insurance',
    jan: ' 1.213.600',
    feb: ' 1.592.850',
    mar: ' 1.517.000',
    apr: ' 1.638.360',
    may: ' 1.638.360',
    jun: ' 1.638.360',
    jul: ' 1.638.360',
    aug: ' 1.638.360',
    sep: ' ',
    oct: ' ',
    nov: ' ',
    dec: ' ',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '12 Insurance',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 10,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: 'Without Classification',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 10,
      },

  {
    id: 11,
    acc_description_edit: 'Taxes & Related Costs',
    jan: ' 1.213.600',
    feb: ' 1.592.850',
    mar: ' 1.517.000',
    apr: ' 1.638.360',
    may: ' 1.638.360',
    jun: ' 1.638.360',
    jul: ' 1.638.360',
    aug: ' 1.638.360',
    sep: ' ',
    oct: ' ',
    nov: ' ',
    dec: ' ',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '19 Taxes & related costs',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 11,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: 'Without Classification',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 11,
      },

  {
    id: 12,
    acc_description_edit: 'Royalties paid',
    jan: ' 1.213.600',
    feb: ' 1.592.850',
    mar: ' 1.517.000',
    apr: ' 1.638.360',
    may: ' 1.638.360',
    jun: ' 1.638.360',
    jul: ' 1.638.360',
    aug: ' 1.638.360',
    sep: ' ',
    oct: ' ',
    nov: ' ',
    dec: ' ',
    parentId: null,
    type: 'step',
  },
      {
    id:  Math.random().toString(36).substr(2, 9),
    acc_description_edit: 'Without Classification',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
    type: 'row',
    parentId: 12,
  },

  {
    id: 13,
    acc_description_edit: 'Other',
    jan: ' 1.213.600',
    feb: ' 1.592.850',
    mar: ' 1.517.000',
    apr: ' 1.638.360',
    may: ' 1.638.360',
    jun: ' 1.638.360',
    jul: ' 1.638.360',
    aug: ' 1.638.360',
    sep: ' ',
    oct: ' ',
    nov: ' ',
    dec: ' ',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '03 Under/Over',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '06 Promotion and advertising',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '07 Freight on sales and related costs',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '08 Sales Comissions',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '09 Travel, entertain, and missions represantations',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '10 Telephone  / Mailling',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '11 External fees and related costs',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '14 Lodging',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '15 Buildings, equipments and tools',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '16 Water and Energy rates',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '17 Office costs and consumptions',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '18 Services Contracts (Security, Other 3rd Serv)',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '21 Temporary, Trainees and Subcontracting',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '22 Information Technology',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '23 Warranty Costs',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '24 Other expenses',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '34 Cost Allocation',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '44 Provisions for doubtful accounts',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: '46 Others Provisions',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description_edit: 'Without Classification',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
        type: 'row',
        parentId: 13,
      },

  {
    id: 14,
    acc_description_edit: 'Allocation Costs',
    jan: ' 1.213.600',
    feb: ' 1.592.850',
    mar: ' 1.517.000',
    apr: ' 1.638.360',
    may: ' 1.638.360',
    jun: ' 1.638.360',
    jul: ' 1.638.360',
    aug: ' 1.638.360',
    sep: ' ',
    oct: ' ',
    nov: ' ',
    dec: ' ',
    parentId: null,
    type: 'step',
  },
      {
    id:  Math.random().toString(36).substr(2, 9),
    acc_description_edit: 'Without Classification',
        jan: ' 1.213.600',
        feb: ' 1.592.850',
        mar: ' 1.517.000',
        apr: ' 1.638.360',
        may: ' 1.638.360',
        jun: ' 1.638.360',
        jul: ' 1.638.360',
        aug: ' 1.638.360',
        sep: ' ',
        oct: ' ',
        nov: ' ',
        dec: ' ',
    type: 'row',
    parentId: 14,
  },

  {
    id: 99,
    acc_description_edit: 'Total Geral',
    jan: ' 1.213.600',
    feb: ' 1.592.850',
    mar: ' 1.517.000',
    apr: ' 1.638.360',
    may: ' 1.638.360',
    jun: ' 1.638.360',
    jul: ' 1.638.360',
    aug: ' 1.638.360',
    sep: ' ',
    oct: ' ',
    nov: ' ',
    dec: ' ',
    parentId: null,
    type: 'step',
  },
]

export const columns = [
  { name: 'acc_description_edit', title: 'ACC DESCRIPTION' , editable: false},
  { name: 'jan', title: 'JAN/21' },
  { name: 'feb', title: 'FEB/21' },
  { name: 'mar', title: 'MAR/21' },
  { name: 'apr', title: 'APR/21' },
  { name: 'may', title: 'MAY/21' },
  { name: 'jun', title: 'JUN/21' },
  { name: 'jul', title: 'JUL/21' },
  { name: 'aug', title: 'AUG/21' },
  { name: 'sep', title: 'sep/21' },
  { name: 'oct', title: 'OCT/21' },
  { name: 'nov', title: 'NOV/21' },
  { name: 'dec', title: 'DEC/21' },
];

export const headerInformation = {
  dateBetween: 'Jan 20 - Dec 20',
  Country: 'Brasil',
  FunctionalArea: '(P65500,P65700)',
  PersonResponsible: 'Camille Forestier',
  UserResponsible: 'SESA368320',
  CostCenter: 'BR016270'
}


